import styled from '@emotion/styled'
import { colors } from 'component-library/__styling/settings'
import { calcRem } from 'component-library/__styling/style-functions'

export const StyledText = styled('p')({
    fontWeight: 'bold',
    borderColor: colors.thewest.greyDolphin, // To be used for PerthNow as well
    borderWidth: '1px',
    borderStyle: 'solid',
    padding: calcRem(6, 0, 6, 10),
})
